import React, { useEffect, useState } from "react";
import { Card, Col, Layout, List, Menu, theme } from "antd";
import { Checkbox } from "antd";
import { Select } from "antd";
import FilterItems from "../../FilterItems.json";
import ListCard from "../CollectionsCard/CollectionsCard";
import FilterTopSection from "./FilterTopSection";
import styles from "./CollectionsFilterPanel.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPublicCollections,
} from "../../Slices/PublicCollectionsDataSlice";
import CollectionsHeader from "../CollectionsHeader/CollectionsHeader";
import PaginationBar from "../Pagination/PaginationBar";
import ErrorPage from "../ErrorPage/ErrorPage";
import { setLogin } from "../../Slices/UserActions";
import { useNavigationType } from "react-router-dom";
import { removeLastWindowNHQ } from "../../Slices/WindowNHQSlice";
import { Helmet } from "react-helmet";

const CollectionsFilterPanel: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { Content, Footer, Sider } = Layout;
  const dispatch: any = useDispatch();
  const collections = useSelector(
    (state: any) => state.publicCollectionsData?.collections
  );


  
  let searchParams:any = new URLSearchParams(window.location.search);
  
  // const status = useSelector((state: any) => state.publicCollectionsData.status);
  const error = useSelector((state: any) => state.publicCollectionsData.error);
  const navigationType = useNavigationType();
  const collectionsLoader = useSelector(
    (state: any) => state.publicCollectionsData.collectionsLoader
  );

  // If I'll not send any payload , it will not work. ?
  useEffect(() => {
    // dispatch(setLogin(true))
    dispatch(fetchPublicCollections({page: searchParams.get('page'), search : searchParams.get('search'), sortBy : searchParams.get('sortBy'), perPage : searchParams.get('per_page')}));
  }, []);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };


  const ProcessItem = (items: any) => {
    if (items === null) return null;

    return items.map((e: any) => {
      return {
        key: e.key,
        icon: "",
        children:
          e.itemType === "dropdownparent" ? null : ProcessItem(e.children),
        label: (() => {
          switch (e.itemType) {
            case "heading":
              return e.label;

            case "checkbox":
              return <Checkbox>{e.label}</Checkbox>;

            case "dropdown":
              return;

            case "dropdownparent":
              return (
                <>
                  {" "}
                  <p>{e.label}</p>
                  <Select
                    defaultValue="Any Year"
                    style={{ width: 200 }}
                    options={
                      e.children
                        ? e.children.map((a: any) => {
                            return { value: a.label, label: a.label };
                          })
                        : []
                    }
                  />{" "}
                </>
              );
          }
        })(),

        type: "group",
      };
    });
  };

  let items = ProcessItem(FilterItems);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  
  useEffect(()=>{
    if(navigationType === 'POP'){
      dispatch(removeLastWindowNHQ())
      // console.log("NAV POP")
    }
    else if (navigationType === 'PUSH'){
      console.log('NAV PUSH')
    }
  }, [])


  return (
    <>
    <Helmet>
    <title>NotableHQ - Collections</title>
        <meta name="description" content="Description" />
        <meta name="theme-color" content="#008f68" />
    </Helmet>
     {/* <link rel="preload" href="/button.css" as="style" /> */}
    {/* <link  rel="import" type="css" href="./CollectionsFilterPanel.module.css" /> */}
      {/* <div className={styles.filterToggleIcon}>
        {" "}
        <i
          style={{
            position: "absolute",
            left: "20px",
            top: "15px",
            fontWeight: "bolder",
          }}
          onClick={toggleCollapsed}
          className="bi bi-list h5"
        ></i>{" "}
      </div> */}
      <Content className={styles.cfpMain}>
        <Layout className={styles.cfpLayout}>
          {/* <Sider
            className={`${styles.filterTop} ${styles.devang}`}
            collapsible
            collapsed={collapsed}
            onCollapse={toggleCollapsed}
            trigger={null}
            breakpoint={"xl"}
            collapsedWidth={0}
            style={{ background: colorBgContainer}}
            width={300}
          >
            <FilterTopSection></FilterTopSection>
            <Menu
              className={styles.filterBottom}
              mode="inline"
              defaultSelectedKeys={["1"]}
              defaultOpenKeys={["sub1"]}
              items={items}
            />
          </Sider> */}

          <Content className={styles.collectionsContent}>
            <Col className={styles.centerContent}>
              <CollectionsHeader />
              {error ? (
                <ErrorPage
                  messageError={JSON.stringify(error)}
                  status={error.data.status}
                  title={error}
                  subTitle={"Sorry, the page you visited does not exist."}
                  button={true}
                />
              ) : (
                <>
                  {" "}
                  <PaginationBar
                    show={collections ? true : false}
                    alignTotalItemsLeft
                  />
                  {collectionsLoader ? (
                    <>
                      <ListCard loading={true} /> <ListCard loading={true} />{" "}
                      <ListCard loading={true} /> <ListCard loading={true} />{" "}
                    </>
                  ) : collections.length < 1 ? (
                    <ErrorPage
                      status={"noresults"}
                      title={"title"}
                      subTitle={"none"}
                      button={false}
                      messageError={"nothing"}
                    />
                  ) : (
                    collections.map((e: any) => (
                      <ListCard
                        key={e.id}
                        id={e.id}
                        slug={e?.slug}
                        title={e.title}
                        creator={e.author.name}
                        profilepic={e.author.pic}
                        tags={e.tags}
                        likes={e.details.likes}
                        dislikes={e.details.dislikes}
                        uploadDate={e.publish_date}
                        description={e.details.description_text}
                        url={e.url}
                        liked={e.liked}
                        disliked={e.disliked}
                        bookmarked={e.bookmarked}
                        votes={e.votes}
                        username={e.author.username}
                        authorId={e?.author.id}
                      ></ListCard>
                    ))
                  )}
                  <PaginationBar
                    show={collections ? true : false}
                    alignTotalItemsLeft
                  />
                </>
              )}
            </Col>
          </Content>
        </Layout>
      </Content>
      {/* <Footer className={styles.filtersFooter}>
        Notable HQ - All Rights Reserved
      </Footer> */}
    </>
  );
};

export default CollectionsFilterPanel;
